/**
 * @generated SignedSource<<46b6bd4b279d1621c2afa39d28da6348>>
 * @relayHash eb54f393fb25b30e6b0f29fe8920b4ce
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID eb54f393fb25b30e6b0f29fe8920b4ce

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateExamInput = {
  clientMutationId?: string | null;
  courseId: string;
  duration: number;
  endTime: string;
  name: string;
  startTime: string;
};
export type newExamMutation$variables = {
  input: CreateExamInput;
};
export type newExamMutation$data = {
  readonly createExam: {
    readonly exam: {
      readonly id: string;
    };
  } | null;
};
export type newExamMutation = {
  response: newExamMutation$data;
  variables: newExamMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateExamPayload",
    "kind": "LinkedField",
    "name": "createExam",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Exam",
        "kind": "LinkedField",
        "name": "exam",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "newExamMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "newExamMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "eb54f393fb25b30e6b0f29fe8920b4ce",
    "metadata": {},
    "name": "newExamMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "4892019a444bad92784f824635bec35d";

export default node;
